import React from "react";
import AccordionEditable from "../../../../../components/ui/accordions/AccordionEditable";
import PTFBackgroundSection from "../utils/PTFBackgroundSection";
import BTFBackgroundSection from "../utils/BTFBackgroundSection";

const BackgroundSection = ({ filing, services }) => {
  // Get background data
  const ptfBackground = filing.tax_situation?.details?.PTF?.background;
  const btfBackground = filing.tax_situation?.details?.BTF?.background;

  // Get situation data
  const ptfSituation = filing.tax_situation?.details?.PTF?.situation;
  const btfSituation = filing.tax_situation?.details?.BTF?.situation;

  // Determine visibility based on service and presence of data
  const hasPTF = services.includes("PTF") && ptfBackground;
  const hasBTF = services.includes("BTF") && btfBackground;

  // The "Gatekeeper" check moved from the parent
  if (!(hasPTF || hasBTF || ptfSituation || btfSituation)) {
    return null;
  }

  return (
    <AccordionEditable
      key="background-info"
      title="Background Information"
      hasRequiredActions={false}
      allActionsComplete={true}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        {(hasPTF || ptfSituation) && (
          <PTFBackgroundSection
            background={ptfBackground}
            situation={ptfSituation}
          />
        )}
        {(hasBTF || btfSituation) && (
          <BTFBackgroundSection
            background={btfBackground}
            situation={btfSituation}
          />
        )}
      </div>
    </AccordionEditable>
  );
};

export default BackgroundSection;
